import { useContext } from "react";
import Home from "./Home";
import MusicChannel from "../Channels/MusicChannel";
import RoyaleChannel from "../Channels/RoyaleChannel";
import SelectChannel from "../Channels/SelectChannel";
import PlanetaChannel from "../Channels/PlanetaChannel";
import PageSwiper from "./PageSwiper";
import { PageContext } from "../../../context/PageContext";

function Page(){
    const pageContext = useContext(PageContext)
    return (
        <>
            {(pageContext.activePage === "home" || pageContext.activePage === null) && <PageSwiper name="home"><Home /></PageSwiper>}
            {pageContext.activePage === "pmcMusicChannel" && <PageSwiper name="pmcMusicChannel"><MusicChannel /></PageSwiper>}
            {pageContext.activePage === "pmcRoyaleChannel" && <PageSwiper name="pmcRoyaleChannel"><RoyaleChannel /></PageSwiper>}
            {pageContext.activePage === "pmcSelectRadio" && <PageSwiper name="pmcSelectRadio"><SelectChannel /></PageSwiper>}
            {pageContext.activePage === "pmcPlanetaRadio" && <PageSwiper name="pmcPlanetaRadio"><PlanetaChannel /></PageSwiper>}
        </>
    )
}
export default Page;